import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState('light');
  const [resolvedTheme, setResolvedTheme] = useState('light');

  useEffect(() => {
    // Load saved theme preference from localStorage.
    // Migrate any legacy 'system' value → the currently resolved OS theme,
    // since 'system' is no longer a user-facing option.
    const saved = localStorage.getItem('theme');
    if (saved === 'light' || saved === 'dark') {
      setTheme(saved);
    } else {
      const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      const migrated = systemPrefersDark ? 'dark' : 'light';
      setTheme(migrated);
      localStorage.setItem('theme', migrated);
    }
  }, []);

  useEffect(() => {
    setResolvedTheme(theme);

    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  const setThemePreference = (newTheme) => {
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme: setThemePreference, resolvedTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
